<template>
    <div class="contact-us">
        <div class="contact-us__container">
            <div class="contact-us__head">
                <div class="contact-us__head__title">
                    {{ getTranslatedText("We’d love to hear from you!") }}
                </div>
                <div class="contact-us__head__des">
                    {{ getTranslatedText("Don’t hesitate to connect with us… ") }}
                </div>
            </div>
            <div class="contact-us__content">
                <div class="contact-us__content-left">
                    <FormCommon
                        :formItem="formItem"
                        :dataForm="dataForm"
                        @on-bur-input="onBurInputFormData"
                        @update-form-data="updateFormData"
                        @onSubmitForm="onSubmitForm"
                        classContainer="contact-us__content-left__form"
                    >
                        <b-input-group-prepend
                            slot="propend-phone-number"
                            class="phone-code"
                        >
                            <button
                                class="show-dropdown"
                                type="button"
                                @click="showDropDow"
                            >
                                <img
                                    class="user-avatar"
                                    :src="
                                    require(`@/assets/images/flags/${dataForm.flag}`)
                                "
                                    :alt="dataForm.flag"
                                />
                                <span class="name-country">{{
                                        dataForm.nameCountry
                                    }}</span>
                                ({{ dataForm.calling_code }})
                            </button>

                            <b-dropdown ref="select_phone_code">
                                <b-form-input
                                    v-model="textSearchPhoneNumber"
                                    :placeholder="getTranslatedText('search')"
                                    @input="onChangeFilterPhoneNumbers"
                                ></b-form-input>
                                <b-dropdown-item
                                    @click="selectPhoneCode(item)"
                                    v-for="(item, index) in phoneNumbersFilter"
                                    :key="index"
                                >
                                    <div>
                                        <img
                                            class="user-avatar"
                                            :src="
                                            require(`@/assets/images/flags/${item.flag}`)
                                        "
                                            :alt="item.flag"
                                        />
                                        <span class="name-country">{{
                                                item.name
                                            }}</span>
                                        ({{ item.number }})
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-input-group-prepend>
                    </FormCommon>
                    <b-button @click="onSubmitForm" class="contact-us__content-left__submit">
                        {{ getTranslatedText("Send Message") }}
                    </b-button>
                </div>
                <div class="contact-us__content-right">
                    <div class="contact-us__content-right__head">
                        <div class="contact-us__content-right__head__left">
                            <div class="contact-us__content-right__head__title">
                                {{ getTranslatedText("HEAD OFFICE ADDRESS") }}
                            </div>
                            <div class="contact-us__content-right__head__left__content">
                                <div class="contact-us__content-right__head__content__item">
                                    <div class="contact-us__content-right__head__content__item__icon">
                                        <img class="map-icon" src="@/assets/images/static-pages/contact-us/map-icon.png" />
                                    </div>
                                    {{ getTranslatedText("45 bausher, ghala ind, way no 319 building 110, floor 3 muscat, oman") }}
                                </div>
                            </div>
                        </div>
                        <div class="contact-us__content-right__head__right">
                            <div class="contact-us__content-right__head__title">
                                {{ getTranslatedText("CONTACT INFO") }}
                            </div>
                            <div class="contact-us__content-right__head__right__content">
                                <a
                                    :href="`tel:${getTranslatedText(`+968 2264 8383`)}`"
                                    class="contact-us__content-right__head__content__item"
                                >
                                    <div class="contact-us__content-right__head__content__item__icon">
                                        <img src="@/assets/images/static-pages/contact-us/phone-icon.png" />
                                    </div>
                                    {{ getTranslatedText("+968 2264 8383") }}
                                </a>
                                <a
                                    href="mailto:support@omillionaire.com"
                                    class="contact-us__content-right__head__content__item"
                                >
                                    <div class="contact-us__content-right__head__content__item__icon">
                                        <img src="@/assets/images/static-pages/contact-us/email.png" />
                                    </div>
                                    {{ getTranslatedText("support@omillionaire.com") }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="contact-us__content-right__map">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8478.945336814015!2d58.36387747740888!3d23.58382471142113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8e01d05ab7d965%3A0x561a0705245dc3b0!2sO*21%20Millionaire!5e0!3m2!1sen!2s!4v1667290979926!5m2!1sen!2s"
                            width="100%"
                            height="320"
                            style="border:0;"
                            allowfullscreen=""
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                        />
                    </div>
                    <div class="contact-us__content-right__socials">
                        <div class="contact-us__content-right__socials__title">
                            {{ getTranslatedText("Stay Connected with Us!") }}
                        </div>
                    </div>
                    <div class="contact-us__content-right__socials__content">
                        <a
                            href="https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww/featured"
                            target="_blank"
                            class="contact-us__content-right__socials__content__item"
                        >
                            <img src="@/assets/images/static-pages/contact-us/youtube-icon.png" />
                            {{ getTranslatedText("Youtube") }}
                        </a>
                        <a
                            href="https://www.facebook.com/OMillionaireom-110101778237267/"
                            target="_blank"
                            class="contact-us__content-right__socials__content__item"
                        >
                            <img src="@/assets/images/static-pages/contact-us/facebook.png" />
                            {{ getTranslatedText("Facebook") }}
                        </a>
                        <a
                            href="https://twitter.com/Omillionaire_me"
                            target="_blank"
                            class="contact-us__content-right__socials__content__item"
                        >
                            <img src="@/assets/images/static-pages/contact-us/twitter.png" />
                            {{ getTranslatedText("Twitter") }}
                        </a>
                        <a
                            href="https://instagram.com/omillionaire.om?igshid=YmMyMTA2M2Y="
                            target="_blank"
                            class="contact-us__content-right__socials__content__item"
                        >
                            <img src="@/assets/images/static-pages/contact-us/instagram.png" />
                            {{ getTranslatedText("Instagram") }}
                        </a>
                        <a
                            href="https://www.tiktok.com/@omillionaire_me"
                            target="_blank"
                            class="contact-us__content-right__socials__content__item"
                        >
                            <img src="@/assets/images/static-pages/contact-us/tiktok.png" />
                            {{ getTranslatedText("Tiktok") }}
                        </a>
                        <a
                            href="https://api.whatsapp.com/message/ETI5TZNTRLWOL1?autoload=1&app_absent=0"
                            target="_blank"
                            class="contact-us__content-right__socials__content__item"
                        >
                            <img src="@/assets/images/static-pages/contact-us/whatsapp.png" />
                            {{ getTranslatedText("WhatsApp") }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <Toast :title="toastData.message" :type="toastData.type" />
    </div>
</template>
<script>
import LanguageMixin from "@/mixins/language/language-mixin";
import ContactService from "@/services/contact.service";
import Toast from "@/components/common/toast/Toast.vue";
import UserService from "@/services/user.service";
import FormCommon from "@/components/common/form";
import {phoneNumbers} from "@/resources/phoneNumber";
import {filterFullTextSearch, isStrEmpty, validateEmail} from "@/components/common/utils";
import { isPossiblePhoneNumber, isValidPhoneNumber, getCountryCallingCode } from "libphonenumber-js";
import parseMax from 'libphonenumber-js/max'

export default {
    mixins: [LanguageMixin],
    props: {
        totalAmount: {
            type: Number,
            default: 0,
        },
        paramCheckout: {
            type: Object,
            default: () => {
                return {};
            },
        },
        isRecurring: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Toast,
        FormCommon
    },
    mounted() {
        if(this.$store.state.isLoggedIn) {
            this.getUserData();
        }
        this.getQuestions();
        this.handleDefaultCountry();
    },
    data() {
        return {
            emailValidate: '',
            phoneValidate: '',
            textSearchPhoneNumber: "",
            phoneNumbersFilter: phoneNumbers,
            dataForm: {
                calling_code: "+968",
                code: "+968",
                flag: "Flag_of_Oman.svg",
                nameCountry: "Oman",
                question_id: 1,
                name: '',
                phone_number: '',
                email: '',
                content: ''
            },
            dataSynerise: {
                question_id: 1,
                name: '',
                phone_number: '',
                email: '',
                content: ''
            },
            formItem: [
                {
                    type: "select",
                    label: "What can we help you with?",
                    name: "question_id",
                    required: true,
                    for: "input-list-help",
                    id: "input-list-help",
                    idGroup: "input-group-list-help",
                    options: [],
                },
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "Example: John Cruz",
                    required: true,
                    name: "name",
                    label: "Name",
                    for: "input-name",
                    id: "input-name",
                    idFormGroup: "contact-us-name",
                    state: null,
                    textInvalid: "Please enter the name least 3 characters",
                },
                {
                    type: "input-group",
                    typeInput: "number",
                    required: true,
                    placeholder: "Example: XXXX XXXX",
                    name: "phone_number",
                    label: "Mobile Number",
                    for: "input-phone",
                    id: "contact-us-phone",
                    prepend: "code",
                    nameSlotInputPrepend: "propend-phone-number",
                    state: null,
                    textInvalid: "",
                },
                {
                    type: "input",
                    typeInput: "email",
                    placeholder: "Example: John@example.com",
                    name: "email",
                    required: true,
                    showIconRequired: false,
                    label: "Email",
                    for: "input-email",
                    id: "input-email",
                    idFormGroup: "register-email",
                    state: null,
                    textInvalid: "please enter email",
                },
                {
                    type: "input-area",
                    typeInput: "text",
                    placeholder: "Please write your queries on the space provided",
                    name: "content",
                    required: true,
                    label: "Details:",
                    for: "input-details",
                    id: "input-details",
                    idFormGroup: "contact-us-details",
                    state: null,
                    textInvalid: "Please enter the details least 3 characters",
                },
            ],
            isLoadingButton: false,
            // siteKeyRecaptcha: SITE_KEY_RECAPTCHA,
            toastData: {
                message: "",
                type: "success",
            },
            isVerifyRecaptcha: false,
            showErrorRequiredCaptcha: false,
            email: '',
            message: '',
        };
    },
    methods: {
        handleDefaultCountry() {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const ct = require('countries-and-timezones');
            const timezone = ct.getTimezone(tz);
            const userCountry = timezone.countries[0];
            const countryCallingCode = `+${getCountryCallingCode(userCountry)}`;
            this.phoneNumbersFilter.forEach(item=> {
                if(item.number === countryCallingCode) {
                    this.dataForm.calling_code = item.number;
                    this.dataForm.code = item.number;
                    this.dataForm.flag = item.flag;
                    this.dataForm.nameCountry = item.name.replace(
                        /^(.{5}[^\s]*).*/,
                        "$1"
                    );
                }
            })
        },
        handleValidatePhoneNumber(phone) {
            const phoneCallingCode = `${this.dataForm.code}${phone}`
            const isPossiblePhone = isPossiblePhoneNumber(phoneCallingCode) === true;
            const isValidType = parseMax(phoneCallingCode)?.getType() === 'MOBILE';
            const isValidNumber = isValidPhoneNumber(phoneCallingCode) === true
            this.formItem[2].state = isPossiblePhone && isValidNumber && isValidType;
        },
        showDropDow() {
            const dropdown = this.$refs.select_phone_code;
            dropdown.show();
        },
        // change phone code
        selectPhoneCode(item) {
            if (
                this.dataForm.calling_code !== item.number &&
                !isStrEmpty(this.dataForm.phone_number)
            ) {
                let event = {
                    target: {
                        value: this.dataForm.phone_number,
                        name: "phone_number",
                    },
                };

                let phoneCode = item.number;

                this.onBurInputFormData(event, phoneCode);
            }
            this.dataForm.calling_code = item.number;
            this.dataForm.code = item.number;
            this.dataForm.flag = item.flag;
            this.dataForm.nameCountry = item.name.replace(
                /^(.{5}[^\s]*).*/,
                "$1"
            );
            this.textSearchPhoneNumber = "";
            this.phoneNumbersFilter = phoneNumbers;
            this.handleValidatePhoneNumber(this.dataForm.phone_number);
        },
        getQuestions() {
            const locale = localStorage.getItem("locale");
            ContactService.questionsContactUs(locale ? locale : 'en').then(res=> {
                this.formItem[0].options=res.data;
                this.dataForm.question_id = this.formItem[0].options[0].value;
            })
        },
        onChangeFilterPhoneNumbers(value) {
            let phoneNumber = [...phoneNumbers];
            if (!isStrEmpty(value)) {
                this.phoneNumbersFilter = filterFullTextSearch(
                    phoneNumber,
                    value,
                    "name",
                    "number"
                );
            } else {
                this.phoneNumbersFilter = phoneNumber;
            }
        },
        async onBurInputFormData(event, phoneCode, ) {
            const { name, value } = event.target;
            let { calling_code, phone_number, email } = this.dataForm;

            if (name === "email" && isStrEmpty(value)) {
                this.dataForm.email = "";
            }

            if(isStrEmpty(phone_number) && this.formItem[2].state !== null) {
                this.formItem[2].state = null;
            }

            if(name === "email" && !isStrEmpty(value)) {
                if(!validateEmail(value)) {
                    this.formItem[3].state = false;
                    this.formItem[3].textInvalid = this.getTranslatedText(
                        "correct email format"
                    );
                } else {
                    this.formItem[3].state = null;
                }
                this.dataForm.email = value;
            }

            switch (true) {
                // check Incorrect email format
                // case name === "email" &&
                // !isStrEmpty(value) &&
                // !validateEmail(value):
                //     this.formItem[3].state = false;
                //     this.formItem[3].textInvalid = this.getTranslatedText(
                //         "correct email format"
                //     );
                //     this.dataForm.email = value;
                //     break;
                case (name === "phone_number" && value !== phone_number && value === ""):
                    this.dataForm.phone_number = ''
                    this.formItem[2].state = null;
                default:
                    break;
            }
        },
        updateFormData(item) {
            let { value, name } = item;

            if(name === "question_id") {
                this.dataForm.question_id = value;
                if(this.dataForm.question_id.length > 0) {
                    this.formItem[0].state = null;
                } else {
                    this.formItem[0].state = false;
                }
            }

            if(name === "email") {
                this.emailValidate = value
                this.dataForm.email = value;
            }

            if(name === "phone_number") {
                this.phoneValidate = value;
                this.handleValidatePhoneNumber(value);
                this.dataForm.phone_number = value;
            }
            if(name === "name") {
                if(this.formItem[1].state === false && value.length > 2) {
                    this.formItem[1].state = null;
                    this.dataForm.name = value;
                } else {
                    this.dataForm.name = value;
                }
            }

            if(name === "content") {
                if(this.formItem[4].state === false && value.length > 2) {
                    this.formItem[4].state = null;
                    this.dataForm.content = value;
                } else {
                    this.dataForm.content = value;
                }
            }
        },
        async onSubmitForm() {
            try {
                this.isLoadingButton = true
                let { phone_number, name, content, email, question_id  } = this.dataForm;
                if (question_id.length < 1) {
                    this.formItem[0].state = false
                    let scrollDiv = document.getElementById("input-list-help").offsetTop;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                    this.isLoadingButton = false
                    return false;
                }

                if (name.length < 3 || this.formItem[1].state === false) {
                    this.formItem[1].state = false
                    let scrollDiv = document.getElementById("input-name").offsetTop;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                    this.isLoadingButton = false
                    return false;
                }

                if (phone_number.length < 1 || this.formItem[2].state === false) {
                    this.formItem[2].state = false
                    let scrollDiv = document.getElementById("contact-us-phone").offsetTop;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                    this.isLoadingButton = false
                    return false;
                }

                if (email.length < 1 || this.formItem[3].state === false) {
                    this.formItem[3].state = false
                    let scrollDiv = document.getElementById("input-email").offsetTop;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                    this.isLoadingButton = false
                    return false;
                }

                if (content.length < 3 || this.formItem[4].state === false) {
                    this.formItem[4].state = false
                    let scrollDiv = document.getElementById("input-details").offsetTop;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                    this.isLoadingButton = false
                    return false;
                }
                if(!isStrEmpty(this.phoneValidate)) {
                    this.handleValidatePhoneNumber(this.phoneValidate);
                }
                ContactService.contactUs({
                    locale: localStorage.getItem("locale"),
                    question_id: this.dataForm.question_id,
                    name: this.dataForm.name,
                    email: this.dataForm.email,
                    phone_number: `${this.dataForm.calling_code}${this.dataForm.phone_number}`,
                    content: this.dataForm.content,
                }).then(res=> {
                    if(res.status === 200) {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "success"
                        );
                        this.dataForm.name= "";
                        this.dataForm.phone_number= "";
                        this.dataForm.email= "";
                        this.dataForm.content= "";
                    } else {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                })
            } catch (error) {
                console.log(error)
                this.isLoadingButton = false
            }
        },
        getUserData() {
            UserService.getDataUser().then((res) => {
                if (res) {
                    this.email = res.email;
                }
            });
        },
        verifyMethod(res) {
            if(res) {
                this.isVerifyRecaptcha = true;
                this.showErrorRequiredCaptcha = false;
            }
        },
        expiredMethod() {
            this.isVerifyRecaptcha = false;
        },
        errorMethod() {
            this.isVerifyRecaptcha = false;
            this.showErrorRequiredCaptcha = false;
        },
        submit() {
            if(this.isVerifyRecaptcha === true) {
                ContactService.contactUs({
                    locale: localStorage.getItem("locale"),
                    email: this.email,
                    content: this.message
                }).then(res=> {
                    if(res.status === 200) {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "success"
                        );
                        this.email = "";
                        this.message = "";
                    } else {
                        this.showToast(
                            this.getTranslatedText(res.message),
                            "error"
                        );
                    }
                })
            } else {
                this.showErrorRequiredCaptcha = true;
            }
        },
        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },
        onVerify(response) {
            if (response) this.robot = true;
        },
    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/static-pages/contact-us.scss"
/>
